import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TexteSeoVisuelBas } from '@components/texte-seo-visuel-bas/models';
import { ImageComponent } from '@shared/components/image';
import { TextSeoComponent } from '@shared/components/text-seo';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-texte-seo-visuel-bas',
  imports: [ImageComponent, TextSeoComponent, TitleComponent],
  templateUrl: './texte-seo-visuel-bas.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TexteSeoVisuelBasComponent extends AbstractDynamicComponent<TexteSeoVisuelBas> {}
